import React, { useEffect, useRef } from "react"
import I18n from "@helper/i18nInstance"
import _ from "lodash"

import "./Calculating.scss"

import { useQuiz } from "@Quiz/context"

const WAIT_WITHOUT_ANI_MILLIS = 3500
const WAIT_WITH_ANI_MILLIS = 5000

export const RawCalculating: React.FC<{done(): void, quiz: Quiz.Api.Quiz}> = ({done, quiz}) => {
  const numQues = quiz.meta.question_results.length

  const doneRef = useRef(done)
  doneRef.current = done

  const withAnimation = numQues > 0 && numQues <= 12
  const withAnimationRef = useRef(withAnimation)
  withAnimationRef.current = withAnimation

  const perRow = withAnimation
    ? Math.ceil(numQues / 2.0)
    : 0
  const numRows = 2

  useEffect(() => {
    const timeout = window.setTimeout(doneRef.current, withAnimationRef.current
      ? WAIT_WITH_ANI_MILLIS
      : WAIT_WITHOUT_ANI_MILLIS)

    return () => { // cleanup
      window.clearTimeout(timeout)
    }
  }, [])

  return (
    <div className="neo__quizCalculating">
      <h2>{I18n.t("quiz.quiz_eval.evaluating", {quiz_type: quiz.meta.type})}</h2>
      {withAnimation
        ? <div className="neo__quizCalculating__indicatorRows" data-testid="quiz-calculating-with-animation">
            {_.times(numRows, (rowIndex) => {
              return <div key={rowIndex} className="neo__quizCalculating__indicatorRow">
                {_.times(perRow, (indexInRow) => {
                  const realIndex = rowIndex * perRow + indexInRow
                  if (realIndex < numQues) {
                    const correct = !!quiz.meta.question_results[realIndex]
                    const className = [
                      "neo__quizCalculating__indicator",
                      `neo__quizCalculating__indicator--${correct ? "correct" : "wrong"}`,
                      `neo__quizCalculating__indicator--index${realIndex}`
                    ].join(" ")
                    return <div className={className} key={realIndex} />
                  } else { return null }
                })}
              </div>
            })}
          </div>
        : <div className="neo__quizCalculating__indicatorRows" data-testid="quiz-calculating-without-animation">
            <div className="neo__quizCalculating__indicatorRow">
              <div key={1} className="neo__quizCalculating__busyThing" />
              <div key={2} className="neo__quizCalculating__busyThing" />
              <div key={3} className="neo__quizCalculating__busyThing" />
            </div>
          </div>}
      <p className="neo__quizCalculating__quizTitle">{quiz.meta.title}</p>
    </div>
  )
}

const Calculating: React.FC<{done(): void}> = ({done}) => {
  const { quiz } = useQuiz()
  if (!quiz?.result) { return null }

  return <RawCalculating quiz={quiz} done={done} />
}

export default Calculating
